module.exports = __webpack_public_path__ + "media/images/corporate-logos/logo-because-61482d7000410b05fe12d28430f5b042.svg";